import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { H3Atom } from '../../atoms/text-atoms/text-atoms';
import { DropdownIconAtom } from '../../atoms/icon-atoms/icon-atoms';
import FilterBox from './filter-box';
import Dropdown from './dropdown';
import RadioInput from './radio-input';
import useOnClickOutside from '../../hooks/use-on-click-outside';
import { generateKey } from '../../utils/utils';
import { GTM_ID } from '../../../../common/constants/gtmIds';

const Sort = ({
  id,
  title = 'sort by',
  radioInputData,
  setCompareFunctionConfig,
  width,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(
    Array.isArray(radioInputData) ? radioInputData[0] : {}
  );

  // setIsOpen(false) if user clicks outside filter
  const ref = useRef();
  useOnClickOutside(ref, () => setIsOpen(false));

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const selectRadio = event => {
    try {
      const label = event.target.value;
      const selectedRadioInputData = radioInputData.find(
        radioInput => radioInput.label === label
      );
      setSelectedRadio(selectedRadioInputData);
      setIsOpen(false);
    } catch (error) {
      console.warn(
        'Error in sort.js -> selectRadio -',
        'event:',
        event,
        'error:',
        error
      );
    }
  };

  useEffect(() => {
    setCompareFunctionConfig(selectedRadio);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRadio]);

  if (Array.isArray(radioInputData)) {
    return (
      <div ref={ref} className={`${className} filter-block-element`}>
        {title && <H3Atom>{title}</H3Atom>}
        <FilterBox
          handleInteraction={toggleOpen}
          width={width}
          isClickable={true}
          gtmId={isOpen ? null : GTM_ID.FILTER_SELECT}
        >
          {'label' in selectedRadio ? selectedRadio.label : 'None selected'}
          <DropdownIconAtom isOpen={isOpen} />
        </FilterBox>
        <Dropdown isOpen={isOpen} setIsOpen={setIsOpen} width={width}>
          {radioInputData.map((radioInput, index) => {
            return (
              <RadioInput
                label={radioInput.label}
                isSelected={selectedRadio.label === radioInput.label}
                handleInteraction={selectRadio}
                key={generateKey(radioInput.label, index)}
              />
            );
          })}
        </Dropdown>
      </div>
    );
  } else {
    console.warn(
      `Sort received non valid argument - radioInputData: ${radioInputData}`
    );
    return null;
  }
};

// === Sort CSS ===
const StyledSort = styled(Sort)`
  ${H3Atom} {
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightRegular};
    margin: 0 0 ${vars.spacingXs} ${vars.spacingXs};
    &::first-letter {
      text-transform: uppercase;
    }
  }
  ${FilterBox} {
    justify-content: space-between;
  }
  ${DropdownIconAtom} {
    pointer-events: none;
  }
`;

export default StyledSort;
